import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress harmless "ResizeObserver loop" errors triggered by third-party SVG libs (e.g. frappe-gantt)
if (typeof window !== "undefined") {
  const ignore = (e) => {
    const msg = e?.message || "";
    if (msg.includes("ResizeObserver")) {
      e.stopImmediatePropagation();
      if (typeof e.preventDefault === "function") e.preventDefault();
      return true;
    }
    return false;
  };
  // Capture phase so we intercept before CRA overlay listens on window
  window.addEventListener("error", ignore, true);
  window.addEventListener("unhandledrejection", (e) => ignore(e.reason), true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
